module.exports = __webpack_public_path__ + "img/JAOC_POP_PestoSauce_square.0129ad0a.png";